<!-- Navbar left -->
<nav class="agr-nav {{ barColor }}">
  <div id="primary-nav">
    <!-- Standard Navigation -->
    @if (!mainNav.hasModularNavigation && activeModule.homepage) {
    <a id="nav-logo-one-module" class="agr-nav-btn" routerLink="/{{ activeModule.homepage }}">
      <img alt="App logo" src="assets/images/logo-white@2x.png" style="padding-right: 8px" />
      <strong>{{ activeModule.name | agrTranslate }}</strong>
    </a>
    } @if (!mainNav.hasModularNavigation && !activeModule.homepage) {
    <span id="nav-logo-one-module" class="agr-nav-btn disabled">
      <img alt="App logo" src="assets/images/logo-white@2x.png" style="padding-right: 8px" />
      <strong>{{ activeModule.name | agrTranslate }}</strong>
    </span>
    }

    <!-- Modular Navigation -->
    @if (mainNav.hasModularNavigation && activeModule.homepage) {
    <a id="nav-logo" class="agr-nav-btn" routerLink="/{{ activeModule.homepage }}">
      <img alt="App logo" src="assets/images/logo-white@2x.png" />
    </a>
    } @if (mainNav.hasModularNavigation && !activeModule.homepage) {
    <span id="nav-logo" class="agr-nav-btn disabled">
      <img alt="App logo" src="assets/images/logo-white@2x.png" />
    </span>
    }

    <!-- dropdown button -->
    @if (mainNav.hasModularNavigation) {
    <div ngbDropdown #dropdown="ngbDropdown" [autoClose]="'outside'" #moduleDropdown="ngbDropdown">
      <button ngbDropdownToggle id="nav-modular-dropdown" class="agr-nav-btn fw-bold" type="button">
        <a>{{ activeModule.name | agrTranslate }}</a>
      </button>
      <div ngbDropdownMenu>
        <!-- modules of mainNav modules-->
        <li class="dropdown-header">
          <input
            type="text"
            id="navigation-filter"
            class="form-control"
            [(ngModel)]="filterText"
            placeholder="{{ 'FILTER' | agrTranslate }}"
            (input)="onNavigationFilterInput()"
            [agrAutoFocus]="dropdown.isOpen()" />
        </li>
        @for (module of mainNav.modules; track module; let index = $index) { @if (index > 0) {
        <div class="dropdown-divider"></div>
        } @if (module.homepage) {
        <h6
          class="dropdown-header text-{{ module.color }} u-cursor-pointer"
          routerLink="/{{ module.homepage }}"
          (click)="moduleDropdown.close()">
          {{ module.name | agrTranslate }}
          <i class="fa fa-home text-gray-500"></i>
        </h6>
        } @if (!module.homepage) {
        <h6 class="dropdown-header text-{{ module.color }}">
          {{ module.name | agrTranslate }}
        </h6>
        } @for (nav of module.navigationDropdown | filter: { key: 'caption', value: filterText }; track nav; let index = $index) { @if
        (!(nav.submenu.length > 0)) {
        <button
          type="button"
          [id]="'nav-item-' + nav.caption"
          ngbDropdownItem
          routerLinkActive="active"
          routerLink="/{{ nav.path }}"
          (click)="moduleDropdown.close()">
          @if (nav.icon) {
          <i class="fa fa-{{ nav.icon }}"></i>
          }
          {{ nav.caption | agrTranslate }}
        </button>
        } @if (nav.submenu.length > 0) {
        <button
          class="dropdown-item dropdown-item-submenu-toggle dropdown-toggle"
          data-toggle="collapse"
          type="button"
          [attr.data-target]="'#collapse-' + nav.caption"
          [id]="'nav-item-' + nav.caption"
          aria-expanded="false"
          [attr.aria-controls]="'collapse-' + nav.caption">
          @if (nav.icon) {
          <i class="fa fa-{{ nav.icon }}"></i>
          }
          {{ nav.caption | agrTranslate }}
        </button>
        } @if (nav.submenu.length > 0) {
        <div class="collapse" [id]="'collapse-' + nav.caption">
          @for (sub of nav.submenu; track sub) { @if (!sub.divider) {
          <button
            class="dropdown-item-submenu-item"
            type="button"
            [id]="'nav-item-' + sub.caption"
            ngbDropdownItem
            routerLinkActive="active"
            routerLink="/{{ sub.path }}"
            (click)="moduleDropdown.close()">
            @if (sub.icon) {
            <i class="fa fa-{{ sub.icon }}"></i>
            }
            {{ sub.caption | agrTranslate }}
          </button>
          } }
        </div>
        } } }
      </div>
    </div>
    }

    <!-- App Navigation -->
    @for (appNav of activeModule.navigation; track appNav) {
    <!-- normal button -->
    @if (appNav.submenu.length === 0) {
    <a class="agr-nav-btn" routerLinkActive="active" routerLink="/{{ appNav.path }}">
      @if (appNav.icon) {
      <i class="fa fa-{{ appNav.icon }}" [class.caption-with-icon]="appNav.icon && appNav.caption"></i>
      }
      {{ appNav.caption | agrTranslate }}
    </a>
    }
    <!-- dropdown button -->
    @if (appNav.submenu.length > 0) {
    <div class="dropdown">
      <button class="dropdown-toggle agr-nav-btn" type="button" data-bs-toggle="dropdown">
        @if (appNav.icon) {
        <i class="fa fa-{{ appNav.icon }}"></i>
        }
        {{ appNav.caption | agrTranslate }}
      </button>
      <div class="dropdown-menu">
        @for (option of appNav.submenu; track option) { @if (!option.divider) {
        <a class="dropdown-item" routerLink="/{{ option.path }}">
          @if (option.icon) {
          <i class="fa fa-{{ option.icon }}"></i>
          }
          {{ option.caption | agrTranslate }}
        </a>
        } @if (option.divider && (option.feature === undefined || (option.feature | agrFeature))) {
        <div class="dropdown-divider"></div>
        } }
      </div>
    </div>
    } }
  </div>

  <div id="secondary-nav">
    <!-- Userlane -->
    @if (userlaneEnabled) {
    <button type="button" class="agr-nav-btn" (click)="assistantClicked()">
      <i class="fa fa-mortar-board"></i>
    </button>
    }
    <!-- Execution list -->
    <agr-execution-list></agr-execution-list>

    <!-- Settings -->
    <div id="nav-settings-dd" class="dropdown">
      <button type="button" class="agr-nav-btn" data-bs-toggle="dropdown">
        <i class="fa fa-cog"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        @if ('customActions' | agrFeature) {
        <a id="custom-actions-itm" class="dropdown-item u-cursor-pointer" (click)="customActionsModal.open()">
          {{ 'CUSTOM_ACTIONS' | agrTranslate }}
        </a>
        } @if ('customActions' | agrFeature) {
        <div class="dropdown-divider"></div>
        }

        <!-- Settings navigation -->
        @for (option of settingsNav.navigation; track option) { @if (!option.divider) {
        <a class="dropdown-item" routerLink="/{{ option.path }}">
          @if (option.icon) {
          <i class="fa fa-{{ option.icon }}"></i>
          }
          {{ option.caption | agrTranslate }}
        </a>
        } @if (option.divider) {
        <div class="dropdown-divider"></div>
        } } @if (settingsNav.navigation.length > 0) {
        <div class="dropdown-divider"></div>
        }

        <a id="clear-settings" class="dropdown-item u-cursor-pointer" (click)="openClearBrowserDataModal()">
          {{ 'CLEAR_BROWSER_DATA' | agrTranslate }}...
        </a>
      </div>
    </div>

    <!-- Info dropdown -->
    <div id="nav-info-dd" class="dropdown">
      <button type="button" class="agr-nav-btn" data-bs-toggle="dropdown" data-cy="nav-info-btn">
        <i class="fa fa-question-circle"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        @for (infoDropdownItem of infoDropdown; track infoDropdownItem) { @if (infoDropdownItem.isEnabled) {
        <a id="{{ infoDropdownItem.caption.toLowerCase() }}" class="dropdown-item" href="{{ infoDropdownItem.url }}" target="_blank">
          {{ infoDropdownItem.caption | agrTranslate }}
        </a>
        } }
        <div class="dropdown-divider"></div>
        <a id="about-agr" class="dropdown-item u-cursor-pointer" (click)="openAboutModal()">{{ 'ABOUT_AGR' | agrTranslate }}</a>
      </div>
    </div>

    <!-- User dropdown -->
    <div id="nav-user-dd" class="dropdown">
      <button class="agr-nav-btn" data-bs-toggle="dropdown">
        {{ sessionService.user?.name }}
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <div class="dropdown-header">
          <h6 id="nav-user-name" class="d-inline">{{ sessionService.user?.name }}</h6>
          <br />
          <span id="nav-user-email">{{ sessionService.user?.email }}</span>
        </div>

        <div class="dropdown-divider"></div>

        <button type="button" id="my-profile" class="dropdown-item" (click)="myProfileModal.open()">
          {{ 'NAV_MY_PROFILE' | agrTranslate }}
        </button>

        <div class="dropdown-divider"></div>

        <button type="button" id="log-out" class="dropdown-item text-center" routerLink="/login" [queryParams]="{ action: 'LOGOUT' }">
          {{ 'LOG_OUT' | agrTranslate }}
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Modals -->
<agr-my-profile (userUpdated)="('onUserUpdated($event)')" #myProfileModal></agr-my-profile>
<agr-custom-actions #customActionsModal></agr-custom-actions>
